var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMidBannerPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.905C13.1421 17.905 16.5 14.5894 16.5 10.4994C16.5 6.40936 13.1421 3.09375 9 3.09375C4.85786 3.09375 1.5 6.40936 1.5 10.4994C1.5 14.5894 4.85786 17.905 9 17.905Z",
    stroke: "#5418F9",
    strokeWidth: 1.12833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.4969L8.25019 11.9782L11.2506 9.01562",
    stroke: "#5418F9",
    strokeWidth: 1.12833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidBannerPoints);
export default __webpack_public_path__ + "static/media/mid-banner-points.c665e6170ac127199cad55286eb5c9d9.svg";
export { ForwardRef as ReactComponent };